/* rr-faq-index — índice de la FAQ montado con los títulos de los grupos que ya
   están en la página. Liquid no puede: una sección no lee los ajustes de sus
   bloques de theme (section.blocks los trae vacíos y con type '@theme'). Así el
   índice siempre coincide con los grupos y con su traducción. Marca el grupo
   que se está leyendo. Sin JS la página funciona igual, sin índice. */
(() => {
  if (customElements.get('rr-faq-index')) return;

  class RRFaqIndex extends HTMLElement {
    connectedCallback() {
      const list = this.querySelector('ol');
      const groups = [...(this.closest('.rr-faqs')?.querySelectorAll('.rr-faqgroup[id]') || [])];
      if (!list || !groups.length) return;

      const links = groups.map((group, i) => {
        const a = document.createElement('a');
        a.className = 'rr-faqs__link';
        a.href = `#${group.id}`;
        const n = document.createElement('span');
        n.className = 'rr-faqs__n';
        n.textContent = String(i + 1).padStart(2, '0');
        const t = document.createElement('span');
        t.textContent = group.querySelector('.rr-faqgroup__title')?.textContent.trim() || '';
        a.append(n, t);
        const li = document.createElement('li');
        li.append(a);
        list.append(li);
        return a;
      });

      const io = new IntersectionObserver((entries) => {
        for (const e of entries) {
          if (!e.isIntersecting) continue;
          const i = groups.indexOf(e.target);
          links.forEach((a, j) => (j === i ? a.setAttribute('aria-current', 'true') : a.removeAttribute('aria-current')));
        }
      }, { rootMargin: '-35% 0px -60% 0px' });
      groups.forEach((g) => io.observe(g));
    }
  }

  customElements.define('rr-faq-index', RRFaqIndex);
})();
